import { FormInput, FormSelect, FormTextarea } from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";
import { CATEGORY, COMMENTS, NAME, PRIORITY, TERM } from "../consts";
import { X } from "lucide-react";
import { capitalize } from "@/lib/utils";

const AddEdit = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isView,
    onCancel,
    isMobile,
    action,
    isEdit,
    isLoading,
    categories,
    terms,
    priorityOptions
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6 lg:min-w-[500px] xl:min-w-[730px]">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">
              {capitalize(action || "")} Pre-defined Tasks
            </DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="relative">
            <div className="bg-white rounded-lg py-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[100px] px-1">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[25px]">
                <FormInput
                  name={NAME}
                  control={form.control}
                  label="Task Name"
                  placeholder="Please enter"
                  error={errors[NAME]?.message}
                  isRequired={requiredFields.includes(NAME)}
                  disabled={isView}
                />
                <FormSelect
                  name={CATEGORY}
                  control={form.control}
                  label="Task Category"
                  placeholder="Please select"
                  error={errors[CATEGORY]?.message}
                  isRequired={requiredFields.includes(CATEGORY)}
                  disabled={isView}
                  options={categories} 
                />
                <FormSelect
                  name={PRIORITY}
                  control={form.control}
                  label="Priority"
                  placeholder="Please select"
                  error={errors[PRIORITY]?.message}
                  isRequired={requiredFields.includes(PRIORITY)}
                  disabled={isView}
                  options={priorityOptions}
                />
                <FormSelect
                  name={TERM}
                  control={form.control}
                  label="Task Term"
                  placeholder="Please select"
                  error={errors[TERM]?.message}
                  isRequired={requiredFields.includes(TERM)}
                  disabled={isView}
                  options={terms}
                />
                <div className="col-span-2">
                  <FormTextarea
                    name={COMMENTS}
                    control={form.control}
                    label="Comments"
                    placeholder="Please enter"
                    error={errors[COMMENTS]?.message}
                    isRequired={requiredFields.includes(COMMENTS)}
                    disabled={isView}
                    className="h-[200px]"
                    maxLength={1000}
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-row justify-end gap-3 py-3 absolute bottom-0 w-full bg-white pb-[25px] z-[3]">
              <Button variant="outline" type="button" onClick={onCancel}>
                Cancel
              </Button>
              {isView ? (
                <></>
              ) : (
                <Button type="submit" disabled={isLoading}>
                  {isLoading ? "Saving..." : isEdit ? "Update" : "Submit"}
                </Button>
              )}
            </div>
          </form>
        </FormProvider>
      </DrawerContent>
    </Drawer>
  );
};

export default AddEdit;
